import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement, ReactElement } from 'react';

import { DynamicSchemaDefinitionFieldInterface } from '../../../../../generated/graphql';
import { SPACING_UNIT } from '../../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../../styleUtility/gridLayout';

interface Props {
  field: Pick<DynamicSchemaDefinitionFieldInterface, 'label'>;
  className?: string;
  children: ReactElement<any>;
}

const Base = ({ field, className, children }: Props & ClassAttributes<HTMLElement>) => (
  <Root className={className}>
    <Label>{field.label}</Label>

    <Value>{children}</Value>
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['20%', `${SPACING_UNIT * 3}px`, `calc(100% - 20% - ${SPACING_UNIT * 3}px)`],
    rows: ['1fr'],
    areas: [['label', '.', 'input']],
  }),
);

const Label = styled(Typography)(gridLayoutItem('label', { justifySelf: 'flex-end' }), {
  textAlign: 'right',
});

const Value = styled('div')(gridLayoutItem('input'));

export default Base;
